import React, { useEffect, useState } from 'react'
// import { useSelector } from "react-redux";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import Header from '../parts/Header'
import NaranciaSubHeader from '../parts/NaranciaSubHeader'
import * as MyAPI from '../../../utils/MyAPI'
import * as AbstructedApi from '../../../utils/AbstructedApi'
import * as UserActions from '../../../actions/UserActions'
import Alert from 'react-s-alert';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

import {
  EditorState,
  RichUtils,
  convertFromHTML,
  ContentState,
  KeyBindingUtil,
  Modifier,
  convertToRaw,
  convertFromRaw,
  ContentBlock,
  genKey,
  SelectionState,
  DefaultDraftBlockRenderMap,
  CompositeDecorator,
} from 'draft-js';
import 'draft-js/dist/Draft.css';
import Editor from '@draft-js-plugins/editor'

// @draft-js-plugins experiments
import createInlineToolbarPlugin from '@draft-js-plugins/inline-toolbar';
import '@draft-js-plugins/inline-toolbar/lib/plugin.css';
import SampleButton from './draft_resources/SampleButton'
import StrikethroughButton from './draft_resources/StrikethroughButton'
import createHighlightPluginOk from './editor_plugins/highlightPluginOk'
import createHighlightPluginNotOk from './editor_plugins/highlightPluginNotOk'
import createHighlightPluginNotDict from './editor_plugins/highlightPluginDict'
import createStrikethroughPlugin from './editor_plugins/strikethroughPlugin'

import { getSelectionEntity, getSelectionText } from 'draftjs-utils'

// Returns Uint8Array of WAV bytes
function getWavBytes(buffer, options) {
  const type = options.isFloat ? Float32Array : Uint16Array
  const numFrames = buffer.byteLength / type.BYTES_PER_ELEMENT

  const headerBytes = getWavHeader(Object.assign({}, options, { numFrames }))
  const wavBytes = new Uint8Array(headerBytes.length + buffer.byteLength);

  // prepend header, then add pcmBytes
  wavBytes.set(headerBytes, 0)
  wavBytes.set(new Uint8Array(buffer), headerBytes.length)

  return wavBytes
}

// adapted from https://gist.github.com/also/900023
// returns Uint8Array of WAV header bytes
function getWavHeader(options) {
  const numFrames =      options.numFrames
  const numChannels =    options.numChannels || 2
  const sampleRate =     options.sampleRate || 44100
  const bytesPerSample = options.isFloat? 4 : 2
  const format =         options.isFloat? 3 : 1

  const blockAlign = numChannels * bytesPerSample
  const byteRate = sampleRate * blockAlign
  const dataSize = numFrames * blockAlign

  const buffer = new ArrayBuffer(44)
  const dv = new DataView(buffer)

  let p = 0

  function writeString(s) {
    for (let i = 0; i < s.length; i++) {
      dv.setUint8(p + i, s.charCodeAt(i))
    }
    p += s.length
  }

  function writeUint32(d) {
    dv.setUint32(p, d, true)
    p += 4
  }

  function writeUint16(d) {
    dv.setUint16(p, d, true)
    p += 2
  }

  writeString('RIFF')              // ChunkID
  writeUint32(dataSize + 36)       // ChunkSize
  writeString('WAVE')              // Format
  writeString('fmt ')              // Subchunk1ID
  writeUint32(16)                  // Subchunk1Size
  writeUint16(format)              // AudioFormat
  writeUint16(numChannels)         // NumChannels
  writeUint32(sampleRate)          // SampleRate
  writeUint32(byteRate)            // ByteRate
  writeUint16(blockAlign)          // BlockAlign
  writeUint16(bytesPerSample * 8)  // BitsPerSample
  writeString('data')              // Subchunk2ID
  writeUint32(dataSize)            // Subchunk2Size

  return new Uint8Array(buffer)
}






const TokenSpan = (props) => {
   return (
     <span data-offset-key={props.offsetkey} style={{
       fontWeight: 'bold',
     }}>
       {props.children}
     </span>
   );
 };

 function getEntityStrategy(mutability) {
   return function(contentBlock, callback, contentState) {
     contentBlock.findEntityRanges(
       (character) => {
         const entityKey = character.getEntity();
         if (entityKey === null) {
           return false;
         }
         return contentState.getEntity(entityKey).getMutability() === mutability;
       },
       callback
     );
   };
 }

 function getEntities(editorState, entityType = null) {
   const content = editorState.getCurrentContent();
   const entities = [];
   content.getBlocksAsArray().forEach((block) => {
     let selectedEntity = null;
     block.findEntityRanges(
       (character) => {
         if (character.getEntity() !== null) {
           const entity = content.getEntity(character.getEntity());
           if (!entityType || (entityType && entity.getType() === entityType)) {
             selectedEntity = {
               entityKey: character.getEntity(),
               blockKey: block.getKey(),
               entity: content.getEntity(character.getEntity()),
             };
             return true;
           }
         }
         return false;
       },
       (start, end) => {
         entities.push({ ...selectedEntity, start, end });
       });
   });
   return entities;
 }




// NaranciaTest
const NaranciaTest = (props) => {

  let dispatch = useDispatch();

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [loading, setLoading] = useState(false);


  let [editorState, setEditorState] = useState(
    () => EditorState.createEmpty(),
  );
  let [{ plugins, InlineToolbar }] = useState(() => {
    const inlineToolbarPlugin = createInlineToolbarPlugin();
    const highlightPluginNotOk = createHighlightPluginNotOk()
    const highlightPluginNotDict = createHighlightPluginNotDict()
    const strikethroughPlugin = createStrikethroughPlugin()
    const highlightPluginOk = createHighlightPluginOk()
    const { InlineToolbar } = inlineToolbarPlugin;
    const plugins = [inlineToolbarPlugin, highlightPluginNotOk, highlightPluginNotDict, strikethroughPlugin, highlightPluginOk];
    return {
      plugins,
      InlineToolbar
    };
  });
  let [lastUsedEntity, setLastUsedEntity] = useState(null)


  const decorator = new CompositeDecorator([
    {
      strategy: getEntityStrategy('IMMUTABLE'),
      component: TokenSpan,
    },
    {
      strategy: getEntityStrategy('MUTABLE'),
      component: TokenSpan,
    },
    {
      strategy: getEntityStrategy('SEGMENTED'),
      component: TokenSpan,
    },
  ]);


  // componentDidMount
  useEffect(() => {
    // _firstScript()

    let _default = {
      blocks: [
        {
          text: (
            'This is an "immutable" entity: Superman. Deleting any ' +
            'characters will delete the entire entity. Adding characters ' +
            'will remove the entity from the range.'
          ),
          type: 'unstyled',
          entityRanges: [{offset: 31, length: 8, key: 'first1'}],
        },
        {
          text: '',
          type: 'unstyled',
        },
        {
          text: (
            'This is a "mutable" entity: Batman. Characters may be added ' +
            'and removed.'
          ),
          type: 'unstyled',
          entityRanges: [{offset: 28, length: 6, key: 'second2'}],
        },
        {
          text: '',
          type: 'unstyled',
        },
        {
          text: (
            'This is a "segmented" entity: Green Lantern. Deleting any ' +
            'characters will delete the current "segment" from the range. ' +
            'Adding characters will remove the entire entity from the range.'
          ),
          type: 'unstyled',
          entityRanges: [{offset: 30, length: 13, key: 'third3'}],
        },
      ],

      entityMap: {
        first1: {
          type: 'TOKEN',
          mutability: 'MUTABLE',
          data: {
            _id: 'first1',
            start: 5,
          },
        },
        second2: {
          type: 'TOKEN',
          mutability: 'MUTABLE',
          data: {
            _id: 'second2',
            start: 8,
          },
        },
        third3: {
          type: 'TOKEN',
          mutability: 'MUTABLE',
          data: {
            _id: 'third3',
            start: 12,
          },
        },
      },
    }

    let _state = convertFromRaw(_default);
    setEditorState(EditorState.createWithContent(_state, decorator))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _getShortAudio = async (start_time) => {

    console.log("NaranciaTest._firstScript: " )

    let end_time = start_time + 5

    let _url = "https://alphatest.shabelab.com/api/narancia_audio?_id=b2899eed42677d455baf97b2ef3a92eb7e30a504568a3d408768882ce83bacb7"

    // https://stackoverflow.com/questions/52925966/how-to-get-blob-data-from-an-existing-audio-element-with-javascript

    // blob
    let _blob = await fetch(_url).then(response => response.blob());
    console.log("_blob: ", _blob)
    console.log("_type: ", _blob.type)
    console.log("_size: ", _blob.size)

    let _blobUrl = URL.createObjectURL(_blob)

    // blob to array buffer
    let _arrayBuffer = await _blob.arrayBuffer()
    console.log("_arrayBuffer: ", _arrayBuffer)

    const audioContext = new AudioContext()

    // array buffer to audio buffer
    let _audioBuffer = await getAudioBufferFromArrayBuffer(_arrayBuffer)
    console.log(_audioBuffer)

    let _channelData = _audioBuffer.getChannelData(0)
    console.log("_channelData: ", _channelData.length )

    let _part_of_channelData = _channelData.slice(start_time*48000, end_time*48000)
    console.log("_part_of_channelData: ", _part_of_channelData.length)

    // create new audio buffer
    let audioCtx = new AudioContext()

    // let myAudioBuffer = audioCtx.decodeAudioData(_part_of_channelData)
    // console.log("myAudioBuffer: ", myAudioBuffer)

    // edit audio buffer
    let myAudioBuffer = audioCtx.createBuffer(1, 48000 * 5, 48000);

    let myAudioFloat32Array = myAudioBuffer.getChannelData(0);
    myAudioFloat32Array = _part_of_channelData
    console.log("myAudioBuffer: ", myAudioBuffer)

    // audio buffer to array buffer
    let myArrayBuffer = myAudioFloat32Array.buffer
    console.log("myAudioFloat32Array.buffer: ", myAudioFloat32Array.buffer)



    // get WAV file bytes and audio params of your audio source
    const wavBytes = getWavBytes(myAudioFloat32Array.buffer, {
      isFloat: true,       // floating point or 16-bit integer
      numChannels: 1,
      sampleRate: 48000,
    })
    console.log("wavBytes: ", wavBytes)



    // convert audio buffer to array buffer
    // let _blob2 = new Blob([buffer]);
    // var view = new DataView(received_data);
    // const wav = new Blob([wavBytes], { type: 'audio/wav' })
    const blob2 = new Blob([wavBytes], {type : 'audio/wav'});
    console.log("blob2: ", blob2)

    // new blob url
    let _blobUrl2 = URL.createObjectURL(blob2)

    // play audio
    let _audio = new Audio()
    _audio.src = _blobUrl2
    _audio.play()
  }

  let getAudioBufferFromArrayBuffer = (_arrayBuffer) => {
    return new Promise((resolve, reject) => {

      let audioContext = new AudioContext()

      // Convert array buffer into audio buffer
      audioContext.decodeAudioData(_arrayBuffer, (audioBuffer) => {
        resolve(audioBuffer)
      })

    })
  }

  //
  // Editor
  //
  // let _onChange = (editorState_new) => {
  //   setEditorState(editorState_new)
  // }

  let _onChange = (editorState_new) => {


    // current content block state
    let content_state_old = editorState.getCurrentContent()
    // upcoming content block state
    let content_state_new = editorState_new.getCurrentContent()

    // check content has changed or not
    if (content_state_old === content_state_new) {
      // same
      setEditorState(editorState_new)

      setLastUsedEntity(null)

      return;
    }



    //upcoming
    let selection_state_new_b = content_state_new.selectionBefore
    let selection_state_new_a = content_state_new.selectionAfter

    // upcoming anchor keys
    let selection_state_new_b_key = selection_state_new_b.getAnchorKey()
    let selection_state_new_a_key = selection_state_new_a.getAnchorKey()
    console.log("selection_state_new_b_key: ", selection_state_new_b_key)
    console.log("selection_state_new_a_key: ", selection_state_new_a_key)

    // upcoming anchor offsets
    let selection_state_new_b_offset = selection_state_new_b.getAnchorOffset()
    let selection_state_new_a_offset = selection_state_new_a.getAnchorOffset()
    console.log("selection_state_new_b_offset: ", selection_state_new_b_offset)
    console.log("selection_state_new_a_offset: ", selection_state_new_a_offset)

    // upcoming focus offsets
    let selection_state_new_b_offset_f = selection_state_new_b.getFocusOffset()
    let selection_state_new_a_offset_f = selection_state_new_a.getFocusOffset()
    console.log("selection_state_new_b_offset_f: ", selection_state_new_b_offset_f)
    console.log("selection_state_new_a_offset_f: ", selection_state_new_a_offset_f)

    //
    // current
    let selection_state_old_a = content_state_old.selectionBefore
    let selection_state_old_b = content_state_old.selectionAfter

    // current keys
    let selection_state_old_b_key = selection_state_old_b.getAnchorKey()
    let selection_state_old_a_key = selection_state_old_a.getAnchorKey()
    console.log("selection_state_old_b_key: ", selection_state_old_b_key)
    console.log("selection_state_old_a_key: ", selection_state_old_a_key)

    // current offsets
    let selection_state_old_b_offset = selection_state_old_b.getAnchorOffset()
    let selection_state_old_a_offset = selection_state_old_a.getAnchorOffset()
    console.log("selection_state_old_b_offset: ", selection_state_old_b_offset)
    console.log("selection_state_old_a_offset: ", selection_state_old_a_offset)


    // this parameter keep returning same if contet not changed
    let _lastType = editorState_new.getLastChangeType()
    console.log("_lastType: ", _lastType)

    if (_lastType === "split-block") {
      return
    }

    if (_lastType === "remove-range") {

      let _entityKey = getSelectionEntity(editorState)

      if (_entityKey) {

        // let selectionState = SelectionState.createEmpty(selection_state_old_b_key);
        let selectionState = SelectionState.createEmpty(selection_state_new_b_key);

        let updatedSelection1 = selectionState.merge({
          focusOffset: selection_state_new_b_offset_f,
          anchorOffset: selection_state_new_a_offset,
        });

        // replace text
        let new_content_state1 = Modifier.replaceText(
          content_state_old,
          updatedSelection1,
          ' ',
          null,
          _entityKey,
        )

        let editor_state2 = EditorState.push(
          editorState,
          new_content_state1,
          'test1',
        )

        var updatedSelection2 = selectionState.merge({
          focusOffset: selection_state_new_a_offset+1,
          anchorOffset: selection_state_new_a_offset,
        });

        setEditorState(EditorState.forceSelection(editor_state2, updatedSelection2))

        return
      }


    } else if (_lastType === "insert-characters") {


      let _entityKey = getSelectionEntity(editorState)
      console.log("_entityKey: ", _entityKey)
      if (!_entityKey && lastUsedEntity) {
        _entityKey = lastUsedEntity
      }

      // let selectionState = SelectionState.createEmpty(selection_state_old_b_key);
      let selectionState = SelectionState.createEmpty(selection_state_new_b_key);

      var updatedSelection1 = selectionState.merge({
        focusOffset: selection_state_new_b_offset,
        anchorOffset: selection_state_new_b_offset,
      });

      let block_state_new_b = content_state_new.getBlockForKey(selection_state_new_b_key)
      let _text = block_state_new_b.getText()
      console.log("_textL: ", _text)

      let _inserted_c = _text.substr(selection_state_new_b_offset_f, 1)

      console.log("_inserted_c: ", _inserted_c)

      let _entity_list = getEntities(editorState)
      console.log("_entity_list.0: ", _entity_list)

      // insert text
      let new_content_state1 = Modifier.insertText(
        content_state_old,
        updatedSelection1,
        _inserted_c,
        null,
        _entityKey,
      )

      let editor_state2 = EditorState.push(
        editorState,
        new_content_state1,
        'test1',
      )

      var updatedSelection2 = selectionState.merge({
        focusOffset: selection_state_new_a_offset,
        anchorOffset: selection_state_new_a_offset,
      });

      setLastUsedEntity(_entityKey)

      setEditorState(EditorState.forceSelection(editor_state2, updatedSelection2))

      return

    } else if ( _lastType === "backspace-character") {

      let _entity_list = getEntities(editorState_new)
      console.log("_entity_list.1: ", _entity_list)

      let _entityKey = getSelectionEntity(editorState)
      console.log("_entityKey: ", _entityKey)

      let _exists = false
      for (let i=0; i<_entity_list.length; i++) {
        if (_entity_list[i].entityKey === _entityKey) {
          _exists = true
        }
      }

      if ( _exists === false && _entityKey ){
        console.log("============ >>>>> wtf!")

        let selectionState = SelectionState.createEmpty(selection_state_new_b_key);

        let updatedSelection1 = selectionState.merge({
          focusOffset: selection_state_new_b_offset_f,
          anchorOffset: selection_state_new_a_offset,
        });

        let _entityKey = getSelectionEntity(editorState)

        // replace text
        let new_content_state1 = Modifier.replaceText(
          content_state_old,
          updatedSelection1,
          ' ',
          null,
          _entityKey,
        )

        let editor_state2 = EditorState.push(
          editorState,
          new_content_state1,
          'test1',
        )

        var updatedSelection2 = selectionState.merge({
          focusOffset: selection_state_new_a_offset+1,
          anchorOffset: selection_state_new_a_offset,
        });

        setEditorState(EditorState.forceSelection(editor_state2, updatedSelection2))
        return
      }

      setLastUsedEntity(_entityKey)

    } else {
      setLastUsedEntity(null)
    }

    // let block_state_new_b = content_state_new.getBlockForKey(selection_state_new_b_key)
    // let length_new_b = -1
    // if (block_state_new_b) {
    //   length_new_b = block_state_new_b.getLength()
    // }
    // console.log("length_new_b: ", length_new_b)
    //
    // let block_state_new_a = content_state_new.getBlockForKey(selection_state_new_a_key)
    // let length_new_a =  block_state_new_a.getLength()
    // console.log("length_new_a: ", length_new_a)
    //
    // // current/old
    // let block_state_old_b = content_state_old.getBlockForKey(selection_state_new_b_key)
    // let length_old_b = -1
    // if (block_state_old_b) {
    //   length_old_b = block_state_old_b.getLength()
    // }
    // console.log("length_old_b: ", length_old_b)

    // // if (block_state_new_b && selection_state_new_b_key !== selection_state_new_a_key) {
    // if (selection_state_new_b_key !== selection_state_new_a_key) {
    //
    //   if (length_old_b === length_new_a +  length_new_b) {
    //     // console.log("split-block or combine blocks ???")
    //
    //     if (length_new_a !== 0) {
    //       // console.log("length_new_a is 0")
    //       return
    //     }
    //     // console.log("新しい空行が追加")
    //     return
    //
    //   } else {
    //
    //     // console.log("WTF?")
    //
    //     if (length_old_b === -1 && _lastType === "split-block") {
    //       // console.log("連続でスプリットが押された？")
    //       return
    //
    //     } else if (length_new_b === -1 && _lastType === "backspace-character") {
    //
    //       if (length_old_b === -1) {
    //         // console.log("バックスペースで単語を連結？")
    //         return
    //       } else {
    //         // console.log("バックスペースで空行を連結？")
    //         return
    //       }
    //     }
    //   }

    setEditorState(editorState_new)
    //
    //   // update flg
    //   if (editorStateUpdated === true) {
    //     setEditorStateUpdated(false)
    //   } else {
    //     setEditorStateUpdated(true)
    //   }
    //
    // } else {
    //
    //   // console.log("something else...")
    //
    //   setEditorState(editorState_new)
    // }
  }

  let _getRaw = () => {
    let rawData = convertToRaw(editorState.getCurrentContent())
    console.log("rawData: ", rawData)
  }


  // make selection ok
  let _sampleButtonClicked = () => {
    console.log("_sampleButtonClicked!!!")
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT_NOT_OK'))
  }

  // make selection ok
  let _strikethroughButtonClicked = () => {
    console.log("_sampleButtonClicked!!!")
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'STRIKETHROUGH'))
  }

  return (
    <div>

      <Header />

      <NaranciaSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
      }}>

        <span>test</span>

        <Row style={{
          marginTop: 10,
          marginBottom: 10,
        }}>

          <Col>
            <span onClick={() => _getShortAudio(5)} style={{
              cursor: 'pointer',
              backgroundColor: '#777777',
              color: '#ffffff',
            }}>
              5 〜
            </span>
          </Col>

          <Col>
            <span onClick={() => _getShortAudio(10)} style={{
              cursor: 'pointer',
              backgroundColor: '#777777',
              color: '#ffffff',
            }}>
              10 〜
            </span>
          </Col>

          <Col>
            <span onClick={() => _getRaw()} style={{
              cursor: 'pointer',
              backgroundColor: '#777777',
              color: '#ffffff',
            }}>
              get raw
            </span>
          </Col>
        </Row>


        <Row style={{
          marginTop: 10,
          marginBottom: 10,
        }}>
          <Col>

            <Editor
              plugins={plugins}
              editorState={editorState}
              onChange={_onChange} />
            <InlineToolbar>
              {
                // may be use React.Fragment instead of div to improve perfomance after React 16
                (externalProps) => (
                  <div>
                    <SampleButton
                      sampleButtonClicked={_sampleButtonClicked}
                      {...externalProps} />

                    <StrikethroughButton
                      sampleButtonClicked={_strikethroughButtonClicked}
                      {...externalProps} />

                  </div>
                )
              }
            </InlineToolbar>

          </Col>
        </Row>

      </Container>

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default NaranciaTest
